import { Dayjs } from "dayjs";

import {
  IFitbitActivityRequest,
  IFitbitActivityResponse,
  IFitbitSleepRequest,
  IFitbitSleepResponse,
} from "../@types/Fitbit";
import {
  ICompleteAuthorizationRequest,
  ICompleteAuthorizationResponse,
} from "../@types/OAuth";
import { ANONYMOUS_REQUEST, api } from "./api";

const WALL_CLOCK_FORMAT = "YYYY-MM-DDTHH:mm:ss";

export const fitbitService = {
  async completeAuthorization(
    request: ICompleteAuthorizationRequest
  ): Promise<ICompleteAuthorizationResponse> {
    // Anonymous callback page (EN-5229): always the default API, never the
    // regional URL a previous sign-in left in browser storage.
    const response = await api.post<ICompleteAuthorizationResponse>(
      "/Mobile/Fitbit/CompleteAuthorization",
      request,
      ANONYMOUS_REQUEST
    );
    return response.data;
  },

  async getPatientActivityData(
    patientId: number,
    fromDate: Dayjs,
    toDate: Dayjs
  ): Promise<IFitbitActivityResponse> {
    const request: IFitbitActivityRequest = {
      patientId,
      fromDate: fromDate.toISOString(),
      toDate: toDate.toISOString(),
    };
    const response = await api.post<IFitbitActivityResponse>(
      "/Portal/Wearable/PatientActivity",
      request
    );
    return response.data;
  },

  async getPatientSleepData(
    patientId: number,
    fromDate: Dayjs,
    toDate: Dayjs
  ): Promise<IFitbitSleepResponse> {
    const request: IFitbitSleepRequest = {
      patientId,
      fromDate: fromDate.format(WALL_CLOCK_FORMAT),
      toDate: toDate.format(WALL_CLOCK_FORMAT),
    };
    const response = await api.post<IFitbitSleepResponse>(
      "/Portal/Sleep/PatientSleep",
      request
    );
    return response.data;
  },
};
